module.exports = __webpack_public_path__ + "media/ดูดเจี๊ยว.b1a27a37.mp3";